/**
 * Created by shbs on 20/06/2018.
 */
// import API from "../api"
import { parseTime } from '../libs/util';

export const formate = {
  methods: {
    parseTime (time, fromat) {
      return parseTime(time, fromat);
    }
  }
};
